// extracted by mini-css-extract-plugin
module.exports = {"valueTextContainer":"DropDownMultiSelectSearch__valueTextContainer","valueText":"DropDownMultiSelectSearch__valueText"};